module.exports = __webpack_public_path__ + "images/big_icon_milestone.png";